<template>
    <el-breadcrumb separator="/">
        <el-breadcrumb-item v-for="(item, index) in data" :key="'bc' + index" :to="{ name: item.name, query: item.query }">
            {{ item.title }}
        </el-breadcrumb-item>
    </el-breadcrumb>
</template>

<script>
export default {
    props: {
        data: { type: Array, default: () => [] }
    }
};
</script>
